//@flow
import React from 'react';
import classnames from 'classnames';
import includes from 'lodash/includes';
import { themr } from 'react-css-themr';
import themedRippleFactory from 'react-toolbox/lib/ripple';
import { checkboxFactory } from 'react-toolbox/lib/checkbox/Checkbox';
import checkFactory from 'react-toolbox/lib/checkbox/Check';
import theme from './style.scss';
import pure from 'recompose/pure';
import { CheckboxTypes } from 'common/components/core/checkbox/constants';

const ThemedCheck = pure(
    checkFactory(themedRippleFactory({ centered: true, spread: 2.6 }))
);

const Checkbox = checkboxFactory(ThemedCheck);

const CheckboxComponent = ({
    theme,
    inverted,
    className,
    checkboxType,
    smallCheckbox,
    checkboxColor,
    testId,
    wrapperClassName,
    ...others
}) => {
    const checkboxTypeClass = includes(CheckboxTypes, checkboxType)
        ? theme[`${checkboxType.toLowerCase()}Checkbox`]
        : null;

    return (
        <div data-test-id={testId} className={theme[wrapperClassName]}>
            <Checkbox
                theme={theme}
                testId={testId}
                className={classnames(className, checkboxTypeClass, {
                    [theme.inverted]: inverted,
                    [theme.smallCheckbox]: smallCheckbox,
                    [theme[checkboxColor]]:
                        checkboxColor && theme[checkboxColor] ? true : false
                })}
                {...others}
            />
        </div>
    );
};

CheckboxComponent.defaultProps = {
    checkboxType: CheckboxTypes.Solid
};
export default themr('CheckboxComponent', theme)(CheckboxComponent);
